/**
 * The Flagsmith client-API URL for listing an environment's flags.
 *
 * Exists because the configured base URL carries a trailing slash
 * (`https://.../api/v1/`), and appending `/flags/` to it produced `/api/v1//flags/`. Flagsmith
 * answers that with **HTTP 200 and the HTML of its own web app** — so the request looked fine,
 * `response.ok` was true, and the flags list was simply empty with no error to explain it.
 *
 * @module Pages/BUs/WhatsNew
 */

/**
 * Joins the configured API base with the flags endpoint, whatever slashes the base has.
 *
 * @example buildFlagsUrl('https://f.gl.com/api/v1/')  // 'https://f.gl.com/api/v1/flags/'
 * @example buildFlagsUrl('https://f.gl.com/api/v1')   // 'https://f.gl.com/api/v1/flags/'
 */
export function buildFlagsUrl(apiUrl: string): string {
  return `${apiUrl.replace(/\/+$/, '')}/flags/`;
}
